import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-meet-our-instructors',
  templateUrl: './meet-our-instructors.component.html',
  styleUrls: ['./meet-our-instructors.component.scss']
})
export class MeetOurInstructorsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
